/** Exportar listas (e quadros) para Excel ou PDF com os filtros da tela. */
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "./feedback";

export type Cell = string | number | null;
export interface ExportTable { columns: string[]; rows: Cell[][] }

/** Busca todas as páginas de uma lista paginada (máx. 5.000 linhas). */
export async function fetchAllPages<T>(url: (skip: number, take: number) => string, max = 5000): Promise<T[]> {
  const out: T[] = [];
  for (let skip = 0; skip < max; skip += 200) {
    const page = await api.get<{ items: T[]; total: number }>(url(skip, 200));
    out.push(...page.items);
    if (out.length >= page.total || page.items.length < 200) break;
  }
  return out.slice(0, max);
}

export function ExportButtons({ title, load }: { title: string; load: () => Promise<ExportTable> }): JSX.Element {
  const [busy, setBusy] = useState<"" | "xlsx" | "pdf">("");
  const run = async (fmt: "xlsx" | "pdf") => {
    setBusy(fmt);
    try {
      const t = await load();
      const stamp = new Date().toLocaleDateString("pt-BR").replace(/\//g, "-");
      const body = { title: `${title} ${stamp}`, sheets: [{ name: title.slice(0, 30), columns: t.columns, rows: t.rows }] };
      await api.downloadPost(fmt === "xlsx" ? "/bi/exportar" : "/bi/exportar-pdf", body, `${title} ${stamp}.${fmt}`);
    } catch (e) {
      toast.error((e as Error).message);
    } finally { setBusy(""); }
  };
  return (
    <div className="row nowrap" style={{ gap: 6 }}>
      <button className="btn small" disabled={!!busy} title="Exportar para Excel (com os filtros atuais)" onClick={() => void run("xlsx")}>{busy === "xlsx" ? "Gerando…" : "Excel"}</button>
      <button className="btn small" disabled={!!busy} title="Exportar para PDF (com os filtros atuais)" onClick={() => void run("pdf")}>{busy === "pdf" ? "Gerando…" : "PDF"}</button>
    </div>
  );
}
